import "../styles/HomeNew.css";

const GRANT_WINDOWS = [
  {
    season: "Spring",
    submit: "February 1st – February 28th",
    decision: "End of Second Quarter (June 30th)",
    emoji: "🌸",
    color: "card--pink",
    chipClass: "lchip--pink",
  },
  {
    season: "Fall",
    submit: "August 1st – August 31st",
    decision: "End of Fourth Quarter (December 31st)",
    emoji: "🍂",
    color: "card--purple",
    chipClass: "lchip--purple",
  },
];

export default function Grant() {
  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero" style={{ minHeight: "44svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr auto" }}>
          <div className="hero__text">
            <p className="hero__kicker">For A Better Tomorrow</p>
            <h1 className="hero__h1">
              Submit a<br />
              <span className="hero__accent">Grant</span>
            </h1>
            <p className="hero__sub">
              FBT accepts grant applications in the first and third quarter of the year.
              We love collaborating with new nonprofits and past grantees alike.
            </p>
            <div className="hero__ctas">
              <a
                href="https://docs.google.com/document/d/1Rh1vmcKUQsfyLjP9HIa1jrgSogazw-1WlVUV4Hwu-0o/edit"
                target="_blank"
                rel="noopener noreferrer"
                className="cta cta--solid"
              >
                Read Grant Guidelines
              </a>
              <a href="#apply" className="cta cta--ghost">Apply Now ↓</a>
            </div>
          </div>
          <div className="hero__stats">
            <div className="hstat hstat--purple">
              <span className="hstat__n">2×</span>
              <span className="hstat__l">Per Year</span>
            </div>
            <div className="hstat hstat--pink">
              <span className="hstat__n">98%</span>
              <span className="hstat__l">Funds to Projects</span>
            </div>
            <div className="hstat hstat--green">
              <span className="hstat__n">🌍</span>
              <span className="hstat__l">Local & Global</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── NOTICE ── */}
      <section className="local" style={{ maxWidth: "800px", marginInline: "auto", paddingBottom: 0 }}>
        <div className="lcard" style={{ background: "var(--pu-50)", borderColor: "var(--pu-200)", flexDirection: "row", gap: "1rem", alignItems: "flex-start" }}>
          <span style={{ fontSize: "1.5rem", flexShrink: 0 }}>📋</span>
          <div>
            <p style={{ fontSize: ".9rem", color: "var(--muted)", lineHeight: 1.75 }}>
              Thanks for your interest in working with For A Better Tomorrow (FBT). Before submitting
              a grant request, kindly take a few minutes to review the{" "}
              <a
                href="https://docs.google.com/document/d/1Rh1vmcKUQsfyLjP9HIa1jrgSogazw-1WlVUV4Hwu-0o/edit"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "var(--pu-500)", fontWeight: 700 }}
              >
                FBT Grant Guidelines ↗
              </a>
              .
            </p>
            <p style={{ fontSize: ".85rem", color: "var(--pk-700)", background: "var(--pk-50)", borderRadius: "8px", padding: ".6rem .9rem", marginTop: ".75rem", fontWeight: 600 }}>
              ⚠️ As of July 2024, FBT will not accept applications from organizations that were
              awarded grants in the previous grant cycle.
            </p>
          </div>
        </div>
      </section>

      {/* ── GRANT WINDOWS ── */}
      <section className="events" style={{ maxWidth: "800px", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Application Windows</span>
          <h2 className="sec-h2">When to Apply</h2>
          <p className="sec-sub">FBT reviews and decides on grants submitted during these two annual windows.</p>
        </div>

        <div className="events__grid" style={{ gridTemplateColumns: "repeat(2, 1fr)" }}>
          {GRANT_WINDOWS.map(g => (
            <div key={g.season} className={`ecard ${g.color}`} style={{ cursor: "default" }}>
              <div className="ecard__icon">{g.emoji}</div>
              <div className="ecard__img" style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                background: g.color === "card--pink" ? "var(--pk-100)" : "var(--pu-100)",
                fontSize: "3rem",
              }}>
                📅
              </div>
              <span className="ecard__label">{g.season} Cycle</span>
              <h3 className="ecard__name">{g.season} Grant Window</h3>
              <div style={{ fontSize: ".85rem", color: "var(--muted)", lineHeight: 1.7 }}>
                <p><strong>Submit:</strong> {g.submit}</p>
                <p style={{ marginTop: ".3rem" }}><strong>Decision by:</strong> {g.decision}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── APPLY ── */}
      <section id="apply" className="local" style={{ background: "var(--off)", maxWidth: "100%", paddingInline: "var(--pad)" }}>
        <div style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
          <div className="sec-hd">
            <span className="sec-eye">Apply Now</span>
            <h2 className="sec-h2">Submit Your Grant Request</h2>
            <p className="sec-sub">Choose the grant type that matches your project's scope and location.</p>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "1.25rem" }}>

            {/* Global Grant */}
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSdhNobh1VopMuIDSFMtb30HetDznRQKkS6Q558jTAka2A2sWA/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="ecard card--purple"
            >
              <div className="ecard__icon">🌍</div>
              <div className="ecard__img" style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "var(--pu-100)", fontSize: "4rem" }}>
                🗺️
              </div>
              <span className="ecard__label">International</span>
              <h3 className="ecard__name">Global Grant Request</h3>
              <p className="ecard__desc">For projects outside the United States that align with FBT's mission of accountable, sustainable philanthropy.</p>
              <span className="ecard__arrow">Apply now →</span>
            </a>

            {/* Local Grant */}
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSdSgC_GSdBKMDTNGLvJ5EZ62Ke1Lgf8mZIlRiUQeOztQK1vGQ/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="ecard card--green"
            >
              <div className="ecard__icon">🏘️</div>
              <div className="ecard__img" style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "var(--gn-100)", fontSize: "4rem" }}>
                🌽
              </div>
              <span className="ecard__label">McLean County</span>
              <h3 className="ecard__name">Local Grant Request</h3>
              <p className="ecard__desc">For Central Illinois and McLean County organizations serving our local community.</p>
              <span className="ecard__arrow">Apply now →</span>
            </a>

            {/* FAQ */}
            <a
              href="https://drive.google.com/file/d/1gGrOwL-EWblfNMbThpmOM9cjIqQ0142n/view?usp=drivesdk"
              target="_blank"
              rel="noopener noreferrer"
              className="ecard card--pink"
            >
              <div className="ecard__icon">❓</div>
              <div className="ecard__img" style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "var(--pk-100)", fontSize: "4rem" }}>
                📖
              </div>
              <span className="ecard__label">Help</span>
              <h3 className="ecard__name">Global Grant FAQs</h3>
              <p className="ecard__desc">Frequently asked questions about the FBT Global Grant Process — read before applying.</p>
              <span className="ecard__arrow">Read FAQs →</span>
            </a>

          </div>
        </div>
      </section>

    </div>
  );
}